import React, { useState, useEffect } from "react";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import strings from "../../../../utils/strings";
import Icons from "../../../../Assets/Icons";
import "./EditConsumable.css";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import { useDispatch, useSelector } from "react-redux";
import { editConsumable, deleteConsumable } from "../../../../modules/NursignCare/AdditonalConsumable/AddConsumableThunk";
import { resetEditConsumable, resetDeleteConsumable } from "../../../../modules/NursignCare/AdditonalConsumable/AddConsumableSlice";
import ToastPopup from "../../../../widgets/Toast/toastPopup";
import useValidation from "../../../../utils/validators";

const EditConsumable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { validateEditConsumable } = useValidation();
  const { editConsumableErr, editConsumableSuccess, deleteConsumableSuccess, deleteConsumableErr } = useSelector((state) => state.addConsumable);
  const nav = useNavigate();
  const location = useLocation();
  const breadcrumbs = ["nursingCare", "manageResource", "additionalConsumables"];
  const paths = [strings.navigation.manageNurseReq, strings.navigation.additionalConsumableList, location.pathname];
  const [selectedUOM, setSelectedUOM] = useState({});
  const [itemName, setItemName] = useState("");
  const [numPcs, setNumPcs] = useState("");
  const [opdInternational, setOpdInternational] = useState("");
  const [opdLocal, setOpdLocal] = useState("");
  const [opdSubsidized, setOpdSubsidized] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const queryParams = queryString.parse(location.search);
  const options = [
    { value: "PCS", label: t("PCS") },
    { value: "PAIR", label: t("Pair") },
    { value: "PACK", label: t("Pack") },
  ];

  useEffect(() => {
    console.log(queryParams);
    const requiredFields = ["_id", "code", "country", "groupId", "groupName", "itemName", "numberOfPcs", "opdInternationalPrice", "opdLocalPrice", "opdSubsidized", "stockUOM"];
    const isMissing = requiredFields.some((field) => !queryParams[field]);
    if (isMissing) {
      nav(strings.navigation.additionalConsumableList);
    } else {
      const defUom = {
        value: queryParams.stockUOM,
        label: queryParams.stockUOM,
      };
      setSelectedUOM(defUom);
      setItemName(queryParams.itemName);
      setNumPcs(queryParams.numberOfPcs.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      setOpdInternational(queryParams.opdInternationalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      setOpdLocal(queryParams.opdLocalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      setOpdSubsidized(queryParams.opdSubsidized.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    }
  }, []);

  useEffect(() => {
    if (editConsumableErr) {
      ToastPopup.error(editConsumableErr);
    }
    if (editConsumableSuccess && editConsumableSuccess.status === "success") {
      nav(strings.navigation.additionalConsumableList);
      ToastPopup.success(t("updatedConsumable", { name: editConsumableSuccess.data.consumable.code }));
      console.log(editConsumableSuccess);
    }
    dispatch(resetEditConsumable());
  }, [editConsumableErr, editConsumableSuccess]);

  useEffect(() => {
    if (deleteConsumableErr) {
      ToastPopup.error(deleteConsumableErr);
    }
    if (deleteConsumableSuccess && deleteConsumableSuccess.status === "success") {
      ToastPopup.success(deleteConsumableSuccess.message);
      nav(strings.navigation.additionalConsumableList);
    }
    dispatch(resetDeleteConsumable());
  }, [deleteConsumableErr, deleteConsumableSuccess]);

  const handleSave = () => {
    const body = {
      itemName: itemName,
      stockUOM: selectedUOM.value,
      numberOfPcs: numPcs.replace(/,/g, ""),
      price: {
        opdInternationalPrice: opdInternational.replace(/,/g, ""),
        opdLocalPrice: opdLocal.replace(/,/g, ""),
        opdSubsidized: opdSubsidized.replace(/,/g, ""),
      },
    };
    const userId = queryParams._id;
    if (validateEditConsumable(body)) {
      console.log(body);
      dispatch(editConsumable({ body, userId }));
    }
  };
  const handleCancel = () => {};
  const handleDelete = () => {
    setShowDeleteModal(false);
    dispatch(deleteConsumable({ userId: queryParams._id }));
  };

  const inputChange = (e) => {
    const { name, value } = e.target;
    if (name) {
      const setters = {
        itemName: setItemName,
        numPcs: setNumPcs,
        opdInternational: setOpdInternational,
        opdLocal: setOpdLocal,
        opdSubsidized: setOpdSubsidized,
      };

      if (["numPcs", "opdInternational", "opdLocal", "opdSubsidized"].includes(name)) {
        const noLeadingZero = value.replace(/^0+/, "");
        const formattedValue = noLeadingZero.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        setters[name](formattedValue);
      } else {
        setters[name](value.trimStart());
      }
    }
  };

  return (
    <div className="dp-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading-row">
        <div className="department-heading">{queryParams.code}</div>
        <div className="department-del-btn" onClick={() => setShowDeleteModal(true)}>
          {t("delete")}
        </div>
      </div>
      <div className="cac-container">
        <div>
          <p className="cac-dropdown-label">
            {t("careGrpName")}
            <span className="asterik">*</span>
          </p>
          <Widgets.NewSelectDropdown options={[]} big placeholder={t("selGrpName")} selectedValue={{ value: queryParams.groupId, label: queryParams.groupName }} disabled />
        </div>
        <div className="cac-body">
          <div className="cac-input-grid">
            <div className="cac-inputs pdl-hn">
              <label>
                {t("code")}
                <span className="asterik">*</span>
              </label>
              <input type="text" className="pdl-number" placeholder={t("code")} value={queryParams.code} disabled />
            </div>
            <div className="cac-inputs pdl-hn">
              <label>
                {t("itemName")}
                <span className="asterik">*</span>
              </label>
              <input type="text" className="pdl-number" value={itemName} name="itemName" onChange={inputChange} placeholder={t("itemName")} />
            </div>
            <div className="cac-inputs pdl-hn">
              <label>
                {t("stockUOM")}
                <span className="asterik">*</span>
              </label>
              <div className="cac-sel-dropdown">
                <Widgets.NewSelectDropdown options={options} big placeholder={t("selGrpName")} noMargin selectedValue={selectedUOM} onChange={(i) => setSelectedUOM(i)} />
              </div>
            </div>
            <div className="cac-inputs pdl-hn">
              <label>
                {t("noOfPieces")}
                <span className="asterik">*</span>
              </label>
              <input type="text" className="pdl-number" value={numPcs} placeholder={t("0")} onChange={inputChange} name="numPcs" />
            </div>
          </div>
          <div className="cac-price-box">
            <section className="cac-title-hr">
              <p className="cac-price-title">Price</p>
              <p className="cac-price-hr"></p>
            </section>
            <div className="dp-price-opd">
              <div className="dp-boxes cac-opd-box">
                <p>{t("opdInterInsured")}</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" value={opdInternational} onChange={inputChange} name="opdInternational" />
                </div>
              </div>
              <div className="dp-boxes cac-opd-box">
                <p>{t("opdLocalInsured")}</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" value={opdLocal} onChange={inputChange} name="opdLocal" />
                </div>
              </div>
              <div className="dp-boxes cac-opd-box">
                <p>{t("opdSubsidized")}</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" value={opdSubsidized} name="opdSubsidized" onChange={inputChange} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="save-speciality cac-save">
          <div className="speciality-cancel" onClick={handleCancel}>
            {t("cancel")}
          </div>
          <div className="speciality-save" onClick={handleSave}>
            {t("save")}
          </div>
        </div>
      </div>
      <Widgets.ConfirmModal showModal={showDeleteModal} handleCancel={() => setShowDeleteModal(false)} handleConfirm={handleDelete} heading="cnfDelItem" description="cndDelItemDes" />
    </div>
  );
};

export default EditConsumable;
